var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 45.8333C36.506 45.8333 45.8334 36.5059 45.8334 25C45.8334 13.494 36.506 4.16663 25.0001 4.16663C13.4941 4.16663 4.16675 13.494 4.16675 25C4.16675 36.5059 13.4941 45.8333 25.0001 45.8333Z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9999 6.25004C14.6446 6.25004 6.24992 14.6447 6.24992 25C6.24992 35.3554 14.6446 43.75 24.9999 43.75C35.3553 43.75 43.7499 35.3554 43.7499 25C43.7499 14.6447 35.3553 6.25004 24.9999 6.25004ZM2.08325 25C2.08325 12.3435 12.3434 2.08337 24.9999 2.08337C37.6564 2.08337 47.9166 12.3435 47.9166 25C47.9166 37.6566 37.6564 47.9167 24.9999 47.9167C12.3434 47.9167 2.08325 37.6566 2.08325 25Z",
    fill: "#2C3E50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0001 14.5834C26.1507 14.5834 27.0834 15.5161 27.0834 16.6667V25C27.0834 26.1506 26.1507 27.0834 25.0001 27.0834C23.8495 27.0834 22.9167 26.1506 22.9167 25V16.6667C22.9167 15.5161 23.8495 14.5834 25.0001 14.5834Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9167 33.3333C22.9167 32.1827 23.8495 31.25 25.0001 31.25H25.0209C26.1715 31.25 27.1042 32.1827 27.1042 33.3333C27.1042 34.4839 26.1715 35.4167 25.0209 35.4167H25.0001C23.8495 35.4167 22.9167 34.4839 22.9167 33.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.291a4ac5688bfbe27372f8bf90cb2a2a.svg";
export { ForwardRef as ReactComponent };